import {
  createContext,
  type PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from "react";
import { useLocation } from "react-router-dom";

import { robotsContent } from "./robots";

const RobotsNoIndexContext = createContext<
  ((forced: boolean) => void) | null
>(null);

export function RouteRobots({
  noIndex = false,
}: {
  readonly noIndex?: boolean;
}) {
  const { pathname, search } = useLocation();

  return (
    <meta
      content={
        noIndex
          ? "noindex,nofollow"
          : robotsContent(pathname, search)
      }
      data-alfabetizando-seo="route-robots"
      name="robots"
    />
  );
}

export function RouteRobotsProvider({
  children,
}: PropsWithChildren) {
  const { pathname, search } = useLocation();
  const [forcedNoIndex, setForcedNoIndex] = useState(false);

  return (
    <RobotsNoIndexContext value={setForcedNoIndex}>
      <meta
        content={
          forcedNoIndex
            ? "noindex,nofollow"
            : robotsContent(pathname, search)
        }
        data-alfabetizando-seo="route-robots"
        name="robots"
      />
      {children}
    </RobotsNoIndexContext>
  );
}

export function useRouteRobotsNoIndex(noIndex: boolean) {
  const setForcedNoIndex = useContext(RobotsNoIndexContext);

  useEffect(() => {
    if (!noIndex || !setForcedNoIndex) {
      return;
    }
    setForcedNoIndex(true);
    return () => {
      setForcedNoIndex(false);
    };
  }, [noIndex, setForcedNoIndex]);
}
